import styled from "styled-components"

import Icon from "icons"

export const ClassShortIcon = styled(Icon)`
  margin-top: -0.5rem;
  color: ${({ theme }) => theme.colors.classesTeal};

  /* IE 11 */
  max-height: 1.7rem;
`

export const ClassCategory = styled.div`
  color: ${({ theme }) => theme.colors.classesTeal};
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
`

export const ClassesLogo = styled.div`
  font-family: Monoline, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2rem;
  color: ${(props) => props.theme.colors.text.primary};

  ::before {
    content: "Mbg";
  }

  ::after {
    content: "Classes";
    color: ${(props) => props.theme.colors.classesTeal};
  }
`

export const BottomRight = styled.div`
  padding: 0.8rem 0rem 0rem 0.8rem;
  border-radius: 100% 0 0 0;
  background: #fff;
`
